"use strict";
// Copyright 2022 Fergal Daly <fergald@gmail.com>.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modes = exports.upgradeEvent = void 0;
exports.fetchEvents = fetchEvents;
// TODO: Move all uses to api/event.
const event_1 = require("./api/event");
Object.defineProperty(exports, "upgradeEvent", { enumerable: true, get: function () { return event_1.upgradeEvent; } });
class Modes {
}
exports.Modes = Modes;
Modes.grid = 'grid';
Modes.linear = 'linear';
Modes.fixed = 'fixed';
function fetchEvents(baseUrl, beginMs, endMs) {
    const url = new URL(baseUrl);
    url.searchParams.set('startTime', beginMs.toString());
    url.searchParams.set('endTime', endMs.toString());
    const f = fetch(url.toString(), { mode: 'cors' });
    return f.then(response => {
        return response.json();
    });
}
